import { render } from "./DividerSquadComponent.vue?vue&type=template&id=01a175e0&scoped=true"
import script from "./DividerSquadComponent.vue?vue&type=script&lang=js"
export * from "./DividerSquadComponent.vue?vue&type=script&lang=js"

import "./DividerSquadComponent.vue?vue&type=style&index=0&id=01a175e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a175e0"]])

export default __exports__